// extracted by mini-css-extract-plugin
module.exports = {"announcer":"announcer_announcer__3z0BO","focusable":"announcer_focusable__1yM8D"};